/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Set/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Set({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/SchedulingPreferences/Content/Weekdays/Set"
  
}) {
let schedulingPreferencesDaysValueData = fromData.useDataFormat({ viewPath,
context: 'scheduling_preferences',
path: 'days',
format: fromHelpers.getWeekdayText,
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="scheduling_preferences.days"
 format="helpers.js getWeekdayText"
 text={schedulingPreferencesDaysValueData}
/>
{children}
</React.Fragment>)
}